function openCollection(evt, tabId) {
    const section = evt.currentTarget.closest('.custom-tabs-section');
    const tabs = Array.from(section.querySelectorAll('.tab-link'));

    // 1. Hide all items
    const contents = section.querySelectorAll('.tab-content');
    contents.forEach(content => content.style.display = 'none');

    // 2. Deactivate all buttons
    tabs.forEach(tab => tab.classList.remove('active'));

    // 3. Show selected
    section.querySelector('#' + tabId).style.display = 'block';
    evt.currentTarget.classList.add('active');

    // 4. SYNC ARROWS: Find the index of the clicked tab and update arrows
    const currentIndex = tabs.indexOf(evt.currentTarget);
    updateArrows(section, currentIndex);
}

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.custom-tabs-section');
    sections.forEach(section => {
        // Find the index of the tab that is active by default (or 0)
        const tabs = Array.from(section.querySelectorAll('.tab-link'));
        const activeIndex = tabs.findIndex(tab => tab.classList.contains('active'));
        updateArrows(section, activeIndex !== -1 ? activeIndex : 0);
    });
});

function updateArrows(section, index) {
    const prevBtn = section.querySelector('.js-prev-tab');
    const nextBtn = section.querySelector('.js-next-tab');
    const tabs = section.querySelectorAll('.tab-link');

    if (!prevBtn || !nextBtn) return;

    prevBtn.style.opacity = (index === 0) ? '0.5' : '1';
    prevBtn.style.pointerEvents = (index === 0) ? 'none' : 'auto';

    nextBtn.style.opacity = (index === tabs.length - 1) ? '0.5' : '1';
    nextBtn.style.pointerEvents = (index === tabs.length - 1) ? 'none' : 'auto';
}

document.addEventListener('click', (event) => {
    const btn = event.target.closest('.js-prev-tab, .js-next-tab');
    if (!btn) return;

    const section = btn.closest('.custom-tabs-section');
    if (!section) return;

    const isNext = btn.classList.contains('js-next-tab');
    const direction = isNext ? 1 : -1;
    const tabs = Array.from(section.querySelectorAll('.tab-link'));
    const activeIndex = tabs.findIndex(tab => tab.classList.contains('active'));

    if (activeIndex === -1) return;

    let newIndex = activeIndex + direction;
    
    if (newIndex >= 0 && newIndex < tabs.length) {
        // Triggering click() here will now run openCollection, 
        // which handles the arrow update for us!
        tabs[newIndex].click();
    }
});

// on document load
const handleRecommendationInsertion = () => {
    const observer = new MutationObserver((mutations, obs) => {
        // Check if the content now contains at least one .product-item
        const hasProduct = document.querySelector('.js-cause-based-recomendations-content .product-item');
        if (hasProduct) {

            const container = document.querySelector('.js-cause-based-recomendations-container');
            const content = document.querySelector('.js-cause-based-recomendations-content');

            container.appendChild(content);

            // Initialize buttons based on screen width
            initDesktopAtcBtns();

            // Task complete: stop watching the DOM
            obs.disconnect();
        }
    });

    // Start observing the content for changes in its children
    observer.observe(document, {
        childList: true,
        subtree: true
    });
};

// Initialize the logic
if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', handleRecommendationInsertion);
} else {
    handleRecommendationInsertion();
}